export const formatPhoneNumber = (phoneNumber: string, countryCode?: string) => {
  if (!phoneNumber) return "";

  if (phoneNumber.startsWith("+")) return phoneNumber;

  const code = countryCode?.replace(/^\+/, "") || "971";

  return `+${code} ${phoneNumber}`;
};
